import React, { useState } from "react";
import PartnersTable from "./components/partners-table/PartnersTable";
import { Button, Modal } from "antd";
import PartnerWizard from "./components/partner-wizard/PartnerWizard";
import PartnersSandboxForm from "../partners-sandbox/PartnersSandboxForm";
import GeneralTableHeader from "../common/general-table-header/GeneralTableHeader";
import {
  PlusCircleOutlined,
  UsergroupAddOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import { useAppSelector } from "../../app/hooks";
import { selectUserAccessLevel } from "../access-control/accountSlice";
import { AccessLevel } from "../../interfaces/accessLevel.enum";
import styles from "./Partners.module.css";

const sandboxPartnerAccessLevels = [
  AccessLevel.KlearlySuperAdmin,
  AccessLevel.KlearlySalesSuperAdmin,
  AccessLevel.KlearlySalesAdmin,
];

export default function Partners() {
  const [isCreateWizardVisible, setIsCreateWizardVisible] = useState(false);
  const [isSandboxVisible, setIsSandboxVisible] = useState(false);
  const userAccessLevel = useAppSelector(selectUserAccessLevel);
  const canCreateSandboxPartner = sandboxPartnerAccessLevels.some((level) =>
    userAccessLevel?.includes(level)
  );

  const actionButtons = [
    <Button
      key="create"
      type="primary"
      onClick={() => setIsCreateWizardVisible(true)}
      icon={<PlusCircleOutlined />}
      size={"middle"}
    >
      Create partner
    </Button>,
  ];
  if (canCreateSandboxPartner) {
    actionButtons.push(
      <Button
        key="sandbox"
        onClick={() => setIsSandboxVisible(true)}
        icon={<ExperimentOutlined />}
        size={"middle"}
      >
        New Sandbox Partner
      </Button>
    );
  }

  return (
    <div className={styles.container}>
      <GeneralTableHeader
        title="Partners"
        description="A list of all of Klearly's partner organisations."
        avatarUrl={<UsergroupAddOutlined style={{ fontSize: "30px" }} />}
        actionButtons={actionButtons}
      />
      <PartnersTable />
      <PartnerWizard
        mode="create"
        visible={isCreateWizardVisible}
        setVisible={setIsCreateWizardVisible}
      />
      <Modal
        title="New Sandbox Partner"
        open={isSandboxVisible}
        onCancel={() => setIsSandboxVisible(false)}
        footer={null}
        destroyOnHidden
        width={640}
      >
        <PartnersSandboxForm />
      </Modal>
    </div>
  );
}
